import deMessages from "./de.json";
import enMessages from "./en.json";

export const SUPPORTED_LOCALES = ["de", "en"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = "en";

type Messages = Record<string, string>;

const MESSAGES: Record<SupportedLocale, Messages> = {
  en: enMessages,
  de: deMessages,
};

export function getMessages(locale: SupportedLocale): Messages {
  return MESSAGES[locale];
}

export function isSupportedLocale(value: string): value is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
